import Cookies from 'js-cookie'
export const getCookie = cookieName => Cookies.get(cookieName)
export const removeCookie = cookieName => Cookies.remove(cookieName)

export const setHoursCookie = (cookieName, cookieValue, hour) => {
  if (getCookie(cookieName) != null) {
    removeCookie(cookieName)
  }
  const date = new Date()
  date.setTime(date.getTime() + (hour * 60 * 60 * 1000))
  Cookies.set(cookieName, cookieValue, { expires: date, sameSite: 'None', secure: true, path: window.location.origin })
}

export const setMinuteCookie = (cookieName, cookieValue, minute) => {
  if (getCookie(cookieName) != null) {
    removeCookie(cookieName)
  }
  const date = new Date()
  date.setTime(date.getTime() + (minute * 60 * 1000))
  Cookies.set(cookieName, cookieValue, { expires: date, sameSite: 'None', secure: true, path: window.location.origin })
}

export const setSecondCookie = (cookieName, cookieValue, second) => {
  if (getCookie(cookieName) != null) {
    removeCookie(cookieName)
  }
  var date = new Date()
  date.setTime(date.getTime() + (second * 1000))
  Cookies.set(cookieName, cookieValue, { expires: date, sameSite: 'None', secure: true, path: window.location.origin })
}
